import { observer } from 'mobx-react-lite'

import classNames from 'classnames'
import { Typography } from 'shared/ui'
import { useMessageFieldContext } from 'widgets/MessageField/context/MessageFieldContext'
import styles from './styles.module.scss'

export const Placeholder = observer(({ className }: { className?: string }) => {
  const messageFieldStore = useMessageFieldContext()
  const { placeholder, messageHtml } = messageFieldStore

  if (messageHtml.length) return null
  if (!placeholder) return null

  return (
    <Typography
      tag={'div'}
      variant={'body-rg-regular'}
      className={classNames(styles.placeholder, className)}
      ariaLabel={'messageField_placeholder'}
    >
      {placeholder}
    </Typography>
  )
})
